import { Form, FormInstance, Row } from "antd";
import { useFetchById } from "../../hooks/useFetchById";
import { Loader } from "../../../../components/Loader";
import { NotificationOptions } from "./NotificationOptions";
import { Comment } from "./Comment";
import { Footer } from "./Footer";
import { useMemo, useState } from "react";
import { SaveAttachments } from "./SaveAttachments";
import { NewDetails } from "./NewDetails";
import { useSetErrorData } from "../../hooks/useSetErrorData";
import { ErrorsContainer } from "./ErrorsContainer";
import { useCloseTask } from "../../hooks/useCloseTask";

type FormItemsProps = {
  id: string;
  close: () => void;
  reload: () => void;
};

export const FormItems = ({ id, close, reload }: FormItemsProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { isLoading, data } = useFetchById(id, form, true);

  const [errors, setErrors] = useState<string[] | null>(null);

  const selectedReceipients = Form.useWatch("notificationRecipientTypes", form);

  useSetErrorData(form, data?.notificationRecipients, setErrors);

  const saveOriginal = Form.useWatch("saveOriginalAttachmentAsDocument", form);

  const showComments: boolean = useMemo(() => {
    let show: boolean = false;

    if (selectedReceipients) {
      const keys = Object.keys(selectedReceipients);

      keys.forEach((key: string) => {
        if (selectedReceipients[key]) {
          show = true;
        }
      });
    }
    return show;
  }, [selectedReceipients]);

  const { submit, isClosing } = useCloseTask(id, form, errors, reload, close);

  return (
    <>
      <Row className="w-100 align-top justify-space-around form-container overflow-y-auto">
        {isLoading ? (
          <Row>
            <Loader fontSize="64px" />
          </Row>
        ) : (
          <Form layout="vertical" requiredMark={false} className="pt-6" form={form} disabled={isClosing}>
            {data.notificationRecipients && (
              <>
                <span className="text-md w-500">Send email notification to selected users:</span>
                <NotificationOptions receipients={data.notificationRecipients} />
              </>
            )}

            {errors && <ErrorsContainer data={errors} />}

            {showComments && <Comment data={data} />}

            {data.fileName && <SaveAttachments />}

            {saveOriginal && <NewDetails form={form} id={id} />}

            {!data.fileName && !data.notificationRecipients && (
              <Row className="d-block pr-8">
                <Row className="mb-4">
                  <p className="my-0">
                    Are you sure you want to close this task? Closing it will mark the task as completed and finish the
                    current workflow.
                  </p>
                </Row>
              </Row>
            )}
          </Form>
        )}
      </Row>
      <Footer isLoading={isLoading} isClosing={isClosing} close={close} submit={submit} />
    </>
  );
};
